module.exports = {
  main: 'Inicio',
  home: 'Tablero',
  info: 'Datos Personal',
  log: 'Movimientos',
  bill: 'Pagos',
  address: 'Direcciones',
  ticket: 'Facturas',
  
  cex_menu: 'Módulo CEX',
  cex: 'Grabar Envios',
  cex_order: 'Envios',
  cex_take: 'Recogidas'
}